import styled from 'styled-components'

export const avatarStyles = {
  marginBottom: '8px'
}

export const UserName = styled.div`
  font-size: 16px;
  line-height: 100%;
  color: #FFFFFF;
  margin-bottom: 3px;
`

export const Role = styled.div`
  font-size: 12px;
  line-height: 100%;
  color: #FFFFFF;
  mix-blend-mode: normal;
  opacity: 0.54;
`

export const DropDownUserName = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #32325D;
`

export const DropDownEmail = styled.div`
  font-size: 14px;
  line-height: 20 px;
  color: rgba(50, 50, 93, 0.54);
`



// WEBPACK FOOTER //
// ./src/components/Profile/NavBarProfile/styles.js